import Checkbox from "@ingka/checkbox";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { getUser, useAppContext } from "../../contextProviders/AppContext";
import { ReminderType } from "../../types/model";

type PropsType = {
  onChange: Function;
  eventReminders: ReminderType[];
};

const Wrapper = styled.div`
  margin: 0 0 var(--space-200) 0;

  .checkbox:nth-child(2) {
    margin-top: var(--space-100);
  }

  ${({ theme }) => `${theme.breakpoints.lg} {
    margin: 0 0 var(--space-300) 0;
  }`}
`;

const Reminders = ({ onChange, eventReminders }: PropsType) => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const user = useSelector(getUser);

  const notificationTypes = eventReminders.map(
    ({ notificationType }: ReminderType) => notificationType
  );
  const [selectedReminders, setSelectedReminders] = useState<string[]>([]);

  const reminderItems = notificationTypes
    .map((type) => ({
      id: type,
      label: t("register.yesReminder", {
        type: t(`register.${type.toLowerCase()}`),
      }),
      checked: selectedReminders.includes(type),
      value: type,
    }))
    .filter((r) => Boolean(user.contact[r.value]));

  useEffect(() => {
    onChange(selectedReminders);
  }, [selectedReminders, onChange]);

  useEffect(() => {
    setSelectedReminders(reminderItems.map((ri) => ri.value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reminderItems.length]);

  const onSelect = (e: any) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedReminders((s) => [...s, value]);
    } else {
      setSelectedReminders((s) => s.filter((r) => r !== value));
    }
  };

  return (
    <Wrapper>
      {reminderItems.map((item, i) => (
        <Checkbox
          key={i}
          id={item.id}
          value={item.value}
          label={item.label}
          onChange={onSelect}
          checked={selectedReminders.includes(item.value)}
        />
      ))}
    </Wrapper>
  );
};

export default Reminders;
